<template>
    <ui-modal
        :title="modalTitle"
        ref="modal"
        :small="false"
    >
        <div
            v-if="! loading"
            class="columns"
        >
            <div class="column is-8">
                <div class="columns is-multiline">
                    <div class="column is-12">
                        <label class="label">{{ trans('app.subject').titleCase() }}</label>

                        <p class="control">
                            <input
                                name="subject"
                                class="input is-large"
                                type="text"
                                v-model="form.subject"
                                required
                            >

                            <span
                                v-if="form.errors.has('subject')"
                                class="help is-danger"
                            >{{ form.errors.first('subject') }}</span>
                        </p>
                    </div>

                    <div class="column is-12">
                        <label class="label">{{ transChoice('app.message', 1).titleCase() }}</label>

                        <p class="control">
                            <trumbowyg
                                v-model="form.message"
                                :config="config"
                                class="form-control"
                                name="message"
                            ></trumbowyg>

                            <span
                                v-if="form.errors.has('message')"
                                class="help is-danger"
                            >{{ form.errors.first('message') }}</span>
                        </p>
                    </div>
                </div>
            </div>

            <div class="column is-4">
                <div class="field content">
                <h2>Select Recipients</h2>

                <p v-if="form.errors.has('recipient')" class="control level start">
                    <span class="icon is-small">
                        <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger">{{ form.errors.first('recipient') }}</span>
                </p>

                <div class="scrollbox">
                    <template
                        v-for="(user, label) in users"
                    >
                         <label class="label" :key="label">{{ label }}</label>
                         <template
                            v-for="u in user"
                         >
                            <p :key="u.id" class="control is-small">
                                <label class="checkbox user-profile" >
                                <input
                                    v-model="form.recipients"
                                    type="checkbox"
                                    name="recipients[]"
                                    :value="u.id"
                                >
                                <img :src="u.small_avatar" /> {{ u.name }}
                                </label>
                            </p>
                         </template>
                    </template>
                </div>
              </div>
            </div>
        </div>
        <div
            v-else
            class="columns"
        >
            <div class="column is-12">
                <div
                    class="centered loader is-medium"
                ></div>
            </div>
        </div>
        <footer slot="footer">
            <a
                class="button is-medium mrs"
                @click="closeModal"
            >{{ trans('app.cancel').titleCase() }}</a>

            <input
                type="button"
                class="button is-success is-medium mrs"
                :value="trans('app.save').titleCase()"
                :disabled="isEmpty"
                @click="submit"
            >
        </footer>
    </ui-modal>
</template>

<script>
import Trumbowyg from 'vue-trumbowyg';
import 'trumbowyg/dist/ui/trumbowyg.css';
import Form from 'form-backend-validation';

export default {
    components: {
        Trumbowyg,
    },

    data () {
        return {
            projects: [],
            users: [],
            loading: true,
            form: new Form({
                message: '',
                subject: '',
                recipients: []
            }),
            config: {
                resetCss: true,
                autogrow: false,
                btns: [
                    ['formatting'],
                    ['strong', 'em', 'del'],
                    ['unorderedList', 'orderedList'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['link'],
                    ['removeformat'],
                    ['fullscreen'],
                    ['viewHTML'],
                ],
            },
        };
    },

    computed: {
        isEdit () {
            return false;
        },

        isEmpty () {
            return _.isEmpty(this.form.recipients) || this.form.message === '' || this.form.subject === '';
        },

        modalTitle () {
            let lang_key = this.isEdit ? 'app.edit_this' : 'app.add_new_this';

            return this.trans(lang_key, {this: this.transChoice('app.message', 1)}).titleCase();
        },

        actionRoute () {
            return this.route('messages.store');
        },

        groupedProjects () {
            let projects = this.projects;

            if (! _.isUndefined(this.projectId)) {
                projects = _.filter(projects, project => project.id === this.projectId);
            }

            return _.chain(projects)
                .sortBy(project => project.account.name)
                .groupBy(project => project.account.name)
                .value();
        },
    },

    listeners: {
        async 'open-message-thread-add-modal' () {
            this.showModal();
            await this.reloadData();
        },
    },

    methods: {
        showModal () {
            this.$refs.modal.show();
        },

        closeModal () {
            this.$refs.modal.hide();
            this.form.reset();
        },

        async fetchProjects () {
            try {
                let { data } = await axios.get(this.route('projects.list'));

                this.projects = data.projects;

            } catch (errors) {
                console.error(errors);
            }
        },

        async fetchUsers() {
            try {
                let { data } = await axios.get(this.route('messages.thread_users'));

                this.users = data.data;
            } catch (errors) {
                console.error(errors);
            }
        },

        async submit () {
            try {
                // @TODO: Not ready for EDIT... as we don't use.
                await this.form.post(this.actionRoute);

                this.closeModal();
                OSPEvent.$emit('message-thread-updated', {});
            } catch (errors) {
                console.error(errors);
            }
        },

        async reloadData() {
            this.loading = true;
            await this.fetchProjects();
            await this.fetchUsers();
            this.loading = false;
        }

    },

    async mounted () {
        await this.reloadData();
    },
};
</script>

<style>
.trumbowyg-box.trumbowyg-editor-visible {
  min-height: 150px !important;
}

.trumbowyg-editor {
  min-height: 150px !important;
}
</style>
